import React from "react";

export default function CreatedOtherServesList() {
  return (
    <div>
      <CreatedOtherServesList api="othercreatedenquiryList" />
    </div>
  );
}
